import React, { useEffect, useState, useRef } from 'react';
import { IgrLegendModule, IgrCategoryChartModule, IgrLegend, IgrCategoryChart } from 'igniteui-react-charts';
import {  getAdminStats } from "../../actions/adminAction";


IgrLegendModule.register();
IgrCategoryChartModule.register();

class ConsultationRenewAbleItem {
  constructor(init) {
    Object.assign(this, init);
  }
  year = '';
  appointments = 0;
  paid = 0;
  unpaid = 0;
  declined = 0;
}


const ConsultationChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const legendRef = useRef(null);
  const chartRef = useRef(null);



  // const formatDate = (dateString) => {
  //   const date = new Date(dateString);
  //   const month = date.toLocaleString('default', { month: 'short' });
  //   const day = date.getDate()+1; 
    
  //   return `${month} ${day}`;
  // };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    date.setHours(date.getHours() + 6);
    
    const month = date.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
    const day = date.getUTCDate();
    
    return `${month} ${day}`;
};

  const getAllstatDashboard = async () => {
    let res = await getAdminStats();
    if (res?.data) {
        setLoading(true);
        const transformedData = res?.data?.orderChartData?.map((item) => new ConsultationRenewAbleItem({
            year: formatDate(item.first), 
            appointments: item.appointments,
            paid: item.paid,
            unpaid: item.unpaid,
            declined: item.declined,
          }));
          setData(transformedData);
          setLoading(false);
    }
  };

  useEffect(() => {
    getAllstatDashboard();
  }, []);

  useEffect(() => {
    if (chartRef.current && legendRef.current) {
      chartRef.current.legend = legendRef.current;
    }
  }, [data]);
  return (
    <div className="card-stats card chart-card latest-consultation-chart" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      width: '100%', 
      padding: '0',
      boxSizing: 'border-box',
    }}>
      <div className="chart-card-header">
        <h4 class="card-title">Consultation Status Trends</h4>
      </div>
      
      <div style={{ padding: '10px' }}>
        <IgrLegend ref={legendRef} orientation="Horizontal" />
      </div>

      <div style={{ flex: 1, position: 'relative', padding: '10px' }}>
        {!loading && data.length > 0 ? (
          <IgrCategoryChart
            ref={chartRef}
            chartType="Line"
            dataSource={data}
            isHorizontalZoomEnabled="true"
            isVerticalZoomEnabled="true"
            includedProperties={['year', 'paid', 'unpaid', 'declined']}
            yAxisTitle="No of Consultation"
            xAxisTitle="Date"
            xAxisLabelTextStyle="10pt Verdana"
            yAxisLabelTextStyle="10pt Verdana"
            xAxisTitleTextStyle="12pt Verdana"
            yAxisTitleTextStyle="12pt Verdana"
            isHorizontalZoomEnabled={false}
            isVerticalZoomEnabled={false}
            width="100%"
            height="100%"
          />
        ) : (
          <div>Loading chart...</div>
        )}
      </div>
    </div>
  );
};

export default ConsultationChart;